import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  chats = 'chats',
  chat = 'chat',
  chatDocument = 'chatDocument',
}

enum ExternalRoutesIds {
  context = 'context',
  projectChat = 'projectChat',
  pulses = 'pulses',
  github = 'github',
}

export const chatsRouteRef = createRouteRef({ id: RoutesIds.chats });

export const rootRouteRef = chatsRouteRef;

export const chatRouteRef = createSubRouteRef({
  id: RoutesIds.chat,
  parent: rootRouteRef,
  path: '/:id',
});

export const chatDocumentRouteRef = createSubRouteRef({
  id: RoutesIds.chatDocument,
  parent: rootRouteRef,
  path: '/:id/documents/:documentId',
});

export const contextRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.context,
  optional: true,
});

export const projectChatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.projectChat,
  params: ['id', 'chatId'],
  optional: true,
});

export const Routes = {
  chats: chatsRouteRef,
  chat: chatRouteRef,
  chatDocument: chatDocumentRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const pulsesRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.pulses,
  optional: true,
});

export const githubRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.github,
  optional: true,
});

export const ExternalRoutes = {
  context: contextRouteRef,
  projectChat: projectChatRouteRef,
  pulses: pulsesRouteRef,
  github: githubRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
